// extracted by mini-css-extract-plugin
export default {"pageTitle":"styles_pageTitle__6CFg1","title":"styles_title__X0NCR","name":"styles_name__yF+OA","search":"styles_search__hpDQF"};